import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import TR from './../../Trans';
import IconButton from '@mui/material/IconButton';
import IntervalService from './../../services/intervals';
import Tooltip from '@mui/material/Tooltip';
import Collapse from '@mui/material/Collapse';
import { Capacitor } from '@capacitor/core';
import { getOS, getPlatform, isIPhone, isPossiblyIPad } from '../../services/os';
import SvgIcon from '@mui/material/SvgIcon';
import HistoryBottomBar from '../items/HistoryBottomBar.js';
import Tabs from '@mui/material/Tabs';
import Alert from '@mui/material/Alert';
import { checkIfMobile } from '../../services/screen';
import Tab from '@mui/material/Tab';
import ContentContainer from '../items/ContentContainer.js';
import CloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import ToggleButton from '@mui/material/ToggleButton';
import DeleteDialog from './../dialogs/DeleteDialog';
import Button from '@mui/material/Button';
import { ReactComponent as SmartQIcon } from './../../assets/smartq.svg';
import sessionStore from '../../stores/session';
import performanceStore from '../../stores/performance';
import navigationStore from '../../stores/navigation.js';
import PerformanceList from './PerformanceList.js';
import SmartQConfirmation from '../dialogs/SmartQConfirmation';
import PerformanceHistory from './PerformanceHistory.js';
import settingsStore from '../../stores/settings';
import playerStore from './../../stores/player';
import PlayQueueBottomBar from '../items/PlayQueueBottomBar.js';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`performances-tabpanel-${index}`}
      aria-labelledby={`performances-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 0 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function tabProps(index) {
  return {
    id: `performances-tab-${index}`,
    'aria-controls': `performances-tabpanel-${index}`,
  };
}

function Performances(props) {

  const [tabValue, setTabValue] = useState(0);
  const [isClearDialogOpen, setIsClearDialogOpen] = useState(false);

  const [isSmartQConfirmationOpen, setIsSmartQConfirmationOpen] = useState(false);

  const handleOpenSmartQConfirmation = () => {
    setIsSmartQConfirmationOpen(true);
  };

  const handleCloseSmartQConfirmation = () => {
    setIsSmartQConfirmationOpen(false);
  };

  const sessionToken = sessionStore((state) => state.sessionToken);
  const safeArea = navigationStore((state) => state.safeArea);
  const isAckSmartQ = sessionStore((state) => state.isAckSmartQ);
  const ackSmartQ = sessionStore((state) => state.ackSmartQ);
  const getHistory = performanceStore((state) => state.getHistory);
  const setSettings = settingsStore((state) => state.setSettings);
  const clearSmartQ = performanceStore((state) => state.clearSmartQ);
  const sortBySmartQ = performanceStore((state) => state.sortBySmartQ);
  const setPaddingBottom = navigationStore((state) => state.setPaddingBottom);
  const settingsSmartQEnabled = settingsStore((state) => state.settings?.smartq_enabled);

  useEffect(() => {

    const syncWidth = () => {
      const rightGrid = document.getElementById("muvika-player-content-container");
      const bottom = document.getElementById("muvika-performances-bottom");

      if (!rightGrid || !bottom) return;
      bottom.style.width = `${rightGrid.offsetWidth}px`;
    };

    // Initial sync
    syncWidth();

    // Add window resize listener
    window.addEventListener("resize", syncWidth);
    window.addEventListener("adjustplayqueuebottom", syncWidth);

    // Cleanup
    return () => {
      window.removeEventListener("resize", syncWidth);
    };
  }, []);

  const [isSmartQNotifOpen, setIsSmartQNotifOpen] = useState(!isAckSmartQ);

  useEffect(() => {
    setPaddingBottom("muvika-performances-list", -35);
  }, []);

  useEffect(() => {
    setIsSmartQNotifOpen(!isAckSmartQ);
  }, [isAckSmartQ]);

  const changeTab = (event, val) => {


    if (val == 0) {
      setPaddingBottom("muvika-performances-list", -35);
    } else if (val == 1) {
      setPaddingBottom("muvika-performances-list", -35);
    }
    setTabValue(val);
  };

  const performanceList = () => {
    return <PerformanceList />;
  };

  const performanceHistory = () => {
    return <PerformanceHistory />;
  };

  const toMinutes = (secs) => {


    var sec_num = parseInt(secs, 10);
    var minutes = Math.floor(sec_num / 60);
    return minutes;
  };

  const renderPlayQueueLabel = () => {
    return <span>{TR.cm_playqueue}</span>;
  };

  const playqueueBottom = () => {
    if (isIPhone() && Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios') {
      return safeArea ? "calc("+safeArea.bottom + "px + 3rem)" : "3rem !important";
    } else if (!isIPhone() && Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios') {
      return safeArea ? "calc("+safeArea.bottom + "px + 0.25rem)" : "0.3rem !important"
    } else if (checkIfMobile()) {
      return "3rem !important"
    } else {
      return "0.1rem";
    }
  };

  const toggleSmartq = () => {
    if (settingsStore.getState().settings) {
      let newSettings = { ...settingsStore.getState().settings };
      newSettings.smartq_enabled = !(settingsSmartQEnabled == 1);
      if (newSettings.smartq_enabled) {
        ackSmartQ();
        sortBySmartQ(sessionToken);
      } else {
        clearSmartQ(sessionToken);
      }
      setSettings(sessionToken, newSettings);
    }
    setIsSmartQConfirmationOpen(false);
  };

  const renderSmartQAlert = () => {
    if (settingsSmartQEnabled) {
      return <Collapse in={isSmartQNotifOpen}>
        <Alert
          severity="warning"
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
                setIsSmartQNotifOpen(false);
                ackSmartQ();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
        >
          {TR.cm_smartq_enabled_notif}
        </Alert>
      </Collapse>;
    }
  };

  const renderBottomBar = () => {
    if (tabValue == 0) {
      return <PlayQueueBottomBar />;
    } else if (tabValue == 1) {
      return <HistoryBottomBar />;
    }
  };

  return (
    <div className={props.className} id="muvika-performances" style={props.style}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={tabValue}
          onChange={changeTab}
          TabIndicatorProps={{
            style: {
              backgroundColor: "var(--selected-color)",
              fontWeight: "var(--selected-font-weight) !important"
            }
          }}>
          <Tab sx={{ color:"var(--text-color)", textTransform: "none", fontSize: "1rem" }} label={renderPlayQueueLabel()} {...tabProps(0)} />
          <Tab sx={{ color:"var(--text-color)",textTransform: "none", fontSize: "1rem" }} label={TR.cm_history} {...tabProps(1)} />
        </Tabs>
      </Box>
      <TabPanel value={tabValue} index={0} className="muvika-perfomances-tab">
        {renderSmartQAlert()}
        {performanceList()}
      </TabPanel>
      <TabPanel value={tabValue} index={1} className="muvika-perfomances-tab">
        {performanceHistory()}
      </TabPanel>

      <Box mt={1} bottom="0" id="muvika-performances-bottom" className="muvika-performances-bottom"
        sx={{
          bottom: playqueueBottom(),
          paddingLeft: safeArea ? safeArea.left + "px" : "0.2rem !important",
          paddingRight: safeArea ? safeArea.right + "px" : "0.2rem !important"
        }}
      >
        {renderBottomBar()}
      </Box>
    </div>
  );
}

export default Performances;